import { render, staticRenderFns } from "./PdfCreate6.vue?vue&type=template&id=0580baa2&scoped=true"
import script from "./PdfCreate6.vue?vue&type=script&lang=js"
export * from "./PdfCreate6.vue?vue&type=script&lang=js"
import style0 from "./PdfCreate6.vue?vue&type=style&index=0&id=0580baa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580baa2",
  null
  
)

export default component.exports